import { useState } from "react";
import { Box, Button, VStack, Text, Spinner } from "@chakra-ui/react";
import TradeStatusToggle from "./wallet/TradeStatusToggle";
import TenetPluginManager from './wallet/TenetPluginManager';
import ApproveTokenSpending from "./wallet/ApproveTokenSpending";
import ApproveExchangeRouter from "./wallet/ApproveExchangeRouter";
import TokenStatusToggle from "./wallet/TokenStatusToggle";


const GetStarted = () => {
  const steps = [
    
    "Approve Spending",
    "Enable Tokens",
    "Enable Trading",    
    
    "Approve Router",

  ];
  
  const [currentStep, setCurrentStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState('');
  const [routerStatus, setRouterStatus] = useState('');

  const handleNextStep = async () => {
    setLoading(true);
    
    try {
      // Simulate async process (e.g., blockchain transactions)
      await new Promise((resolve) => setTimeout(resolve, 2000));
      
      if (currentStep < steps.length - 1) {
        setCurrentStep(currentStep + 1);
      }
    } catch (error) {
      console.error("Error executing step:", steps[currentStep], error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box p={5} minWidth='300px' w='100%' borderWidth={1} bg='white' borderRadius="lg" boxShadow="lg" borderColor={'dodgerblue'}>
      <VStack spacing={4}>
        <Text fontSize="xl" fontWeight="bold">
          Getting Started
        </Text>
        <Text fontSize="md">Step {currentStep + 1}: {steps[currentStep]}</Text>
        
        
        
        {steps[currentStep] === "Approve Spending" && <ApproveTokenSpending setStatus={setStatus}/>}
        {steps[currentStep] === "Enable Trading" && <TradeStatusToggle />}
        {steps[currentStep] === "Enable Tokens" && <TokenStatusToggle />}
        {steps[currentStep] === "Approve Router" && <ApproveExchangeRouter setRouterStatus={setRouterStatus}/>}
        

       
        {status && (
        <Text color={status.includes('Error') ? 'red.500' : 'green.500'} marginTop="20px">
          {status}
        </Text>
      )}
        <Button
          bg='blue'
          //colorScheme="dodgerblue"
          onClick={handleNextStep}
          isLoading={loading}
          color='white'
          loadingText="Processing..."
          isDisabled={currentStep >= steps.length - 1}
        >
          {currentStep < steps.length - 1 ? "Next Step" : "Completed"}
        </Button>
      </VStack>
    </Box>
  );
};

export default GetStarted;
